import React from 'react'
import cx from 'classnames'

import s from './NavDivider.scss'


type NavDividerProps = {
  className: string
}

const NavDivider: React.FunctionComponent<NavDividerProps> = (props) => {
  const { className } = props

  return (
    <li className={cx(className, s.divider, 'border-solid-gray-80')} role="separator" />
  )
}


export default NavDivider
